var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":16,"xs":{span:24,offset:0},"offset":4}},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"titleBox"},[_vm._v(_vm._s(_vm.title))]),_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }